<template>
  <div>
    <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>
    <vue-easy-lightbox
      :visible="isLightboxVisible"
      :imgs="lightboxImg"
      @hide="isLightboxVisible = false"
    />
    <v-container fluid>
      <v-row justify="center" v-if="kines.length>0">
        <v-hover v-slot:default="{ hover }" v-for="item in activeKines" :key="item._id">
          <v-card :elevation="hover ? 12 : 2" class="ma-1 pa-4 pb-0" max-width="300">
            <template>
              <p class="font-weight-bold ow">{{item.name}}</p>
              <v-img
                position="50% 10%"
                class="white--text"
                max-height="120px"
                max-width="180px"
                :alt="item.name"
                style="cursor: pointer;"
                @click="isLightboxVisible=true;lightboxImg=item.photoUrl"
                :src="photoConvert(item.photoUrl)"
                :lazy-src="photoConvert(item.photoUrl)"
              ></v-img>
              <v-card-text>
                <p class="ow mb-1" style="max-width: 150px;">{{ item.city }}, {{ item.country }}</p>
                <p style="max-width: 150px;" class="caption pb-2">
                  <v-clamp autoresize :max-lines="3">{{ item.description }}</v-clamp>
                </p>
              </v-card-text>
              <v-card-actions class="card-actions">
                <v-spacer />
                <v-btn text :to="'/kine/' + item._id">Ouvrir</v-btn>
                <!-- <v-btn icon>
              <v-icon>mdi-heart</v-icon>
                </v-btn>-->
              </v-card-actions>
            </template>
          </v-card>
        </v-hover>
      </v-row>
    </v-container>
    <template>
      <div class="text-center"></div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VClamp from "vue-clamp";
export default {
  data() {
    return {
      lightboxImg: "",
      isLightboxVisible: false
    };
  },
  components: {
    VClamp
  },
  created() {
    if (
      this.kines == null ||
      this.kines == undefined ||
      this.kines.length == 0
    ) {
      this.$store.dispatch("getKines");
    }
  },
  methods: {
    photoConvert(url) {
      if (url === null || url === undefined) {
        return process.env.VUE_APP_API_URL_COACH_AVATAR;
      }
      if (url.startsWith("uploads")) return url;
      else return url + "?height=500";
    }
  },
  computed: {
    ...mapGetters({
      kines: "kines",
      loading: "loading"
    }),
    activeKines: function() {
      return this.kines.filter(function(c) {
        return c.name && c.photoUrl;
      });
    }
  }
};
</script>
<style scoped>
.ow {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
.grow {
  transition: all 0.2s ease-in-out;
}
.grow:hover {
  transform: scale(1.02);
}
.card-actions {
  position: absolute;
  bottom: 0;
}
</style>
